import React from 'react'
import { participantSource, researchActivityModeratedSessionTypes, sessionMethods, statusesOption } from '../../qualitative-surveys/qualitativeUtils'
import { useState } from 'react';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useGlobalContext } from '../../../Contexts/GlobalContext';
import { getAllQualitativeProjects, getAllQualitativeProjectsCount } from '../../qualitative-surveys/qualSurveysActions';
import SurveyTableLoader from '../surveyDetails/components/SurveyTableLoader';
import NoData from '../../../components/NoData';
import { CustomTablePagination } from '../../../Utlils';
import { useNavigate } from 'react-router-dom';

const QualitativeTab = () => {
  const navigate = useNavigate();
  const { user } = useGlobalContext();
  const organizationID = user?.organization?._id;
  const localStorageKey = `qual-survey-tab'`
  const [filters, setFilters] = useState({ search: "" });
  const [debounceSearch, setDebounceSearch] = useState(filters?.search);
  const [tab, setTab] = useState(
    localStorage.getItem(localStorageKey) ? localStorage.getItem(localStorageKey) : 1,
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectRows, setSelectRows] = useState([]);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  }

  const {
    data: qualitativeProjects,
    isLoading: qualitativeProjectsLoading,
    error: qualitativeProjectsError,
  } = useQuery({
    queryKey: ["qualitative-projects", organizationID, page, rowsPerPage, debounceSearch, filters?.participantSource, filters?.sessionMethod, filters?.researchActivityModeratedSessionTypes, statusesOption[tab]?.value],
    queryFn: () => getAllQualitativeProjects({
      organizationID,
      page: page + 1,
      rows: rowsPerPage,
      search: debounceSearch,
      participantSource: filters?.participantSource,
      sessionMethod: filters?.sessionMethod,
      researchActivityModeratedSessionTypes: filters?.researchActivityModeratedSessionTypes,
      tab: statusesOption[tab]?.value || "",
    })
  });
  const {
    data: qualitativeProjectsCount,
    isLoading: qualitativeProjectsCountLoading,
    error: qualitativeProjectsCountError,
  } = useQuery({
    queryKey: ["qualitative-projects", "count", organizationID, debounceSearch, filters?.participantSource, filters?.sessionMethod, filters?.researchActivityModeratedSessionTypes],
    queryFn: () => getAllQualitativeProjectsCount({
      organizationID,
      search: debounceSearch,
      participantSource: filters?.participantSource,
      sessionMethod: filters?.sessionMethod,
      researchActivityModeratedSessionTypes: filters?.researchActivityModeratedSessionTypes,
    })
  });


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    let timer = setTimeout(() => {
      setDebounceSearch(filters?.search);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.search]);

  // console.log({
  //   qualitativeProjects,qualitativeProjectsLoading,qualitativeProjectsError
  // });
  // console.log({ qualitativeProjectsCount, qualitativeProjectsCountLoading, qualitativeProjectsCountError });

  // console.log("filters=>",filters);

  // console.log("debounceSearch=>",debounceSearch);
  // console.log("tab=>",tab);

  return (
    <div className='space-y-6'>
      {/* Filters Section */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-4 flex flex-col lg:flex-row lg:items-center justify-between gap-4">

        <div className='flex items-center gap-2 w-4/6'>
          <select
            className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white w-[200px] h-[48px]"
            name="participantSource"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center',
              backgroundSize: '12px',
            }}
            onChange={handleChange}
            value={filters?.participantSource}
          >
            <option value="">Participant Source</option>
            {participantSource?.map((data, key) => (
              <option key={key} value={data?.value}>
                {data?.label}
              </option>
            ))}
          </select>

          <select
            className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white w-[200px] h-[48px]"
            name="researchActivityModeratedSessionTypes"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center',
              backgroundSize: '12px',
            }}
            onChange={handleChange}
            value={filters?.researchActivityModeratedSessionTypes}
          >
            <option value=""> Session Types</option>
            {researchActivityModeratedSessionTypes?.map((data, key) => (
              <option key={key} value={data?.value}>
                {data?.label}
              </option>
            ))}
          </select>

          <select
            className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white w-[200px] h-[48px]"
            name="sessionMethod"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center',
              backgroundSize: '12px',
            }}
            onChange={handleChange}
            value={filters?.sessionMethod}
          >
            <option value=""> Session Methods</option>
            {sessionMethods?.map((data, key) => (
              <option key={key} value={data?.value}>
                {data?.label}
              </option>
            ))}
          </select>
        </div>
        <div className='w-2/6'>
          <input
            type='search'
            placeholder='Search by project name or project id'
            className='w-full py-2 px-4 rounded-md border border-[#E0E0E0] placeholder:text-sm'
            name='search'
            onChange={handleChange}
          />
        </div>
      </div>
      {/* Tabs and Table */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
        <div className="w-full bg-white">
          <div className="w-full flex items-center gap-4 md:gap-8 px-4 md:px-6 py-3 border-b border-[#E0E0E0] overflow-x-auto no-scrollbar transition-all">
            {statusesOption?.map((item, ind) => (
              <button
                key={ind}
                type="button"
                className={`text-[13px] md:text-[14px] font-[500] cursor-pointer transition-all pb-2 border-b-2 whitespace-nowrap capitalize flex-shrink-0 ${tab == ind
                  ? `text-[#0226BE] font-[600] border-[#0226BE]`
                  : `text-[#666] border-transparent hover:text-[#0226BE] hover:border-[#0226BE]/30`
                  }`}
                onClick={(e) => {
                  setTab(ind);
                  setSelectRows([]);
                  setPage(0);
                  localStorage.setItem(localStorageKey, ind);
                }}
              >
                {item?.label}
                <span
                  className={`ml-1 opacity-70 ${tab == ind ? 'font-[600]' : 'font-[400]'}`}
                >
                  (
                  {ind == 0
                    ? qualitativeProjectsCount?.data?.all || 0
                    : qualitativeProjectsCount?.data?.[item?.value?.toLowerCase()] || 0}
                  )
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Table */}
        <div className="w-full flex flex-col">
          {qualitativeProjectsLoading ?
            (<SurveyTableLoader />)
            : qualitativeProjectsError ?
              (<div className=" h-[200px] flex items-center justify-center">
                <h1 className="text-[#666666]">Something went wrong </h1>
              </div>)
              :
              <div className="w-full overflow-x-auto containerScroll">

                <table
                  className="whitespace-nowrap text-left w-full"
                  id="table-to-xls-DATA"
                >
                  <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                    <tr>
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start w-[40px]"></th>
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start min-w-[250px]">
                        Project Name/  Project ID
                      </th>
                      {tab == 0 && <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        Status
                      </th>}
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        Incentive
                      </th>
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        No Of Participants
                      </th>
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        Feasibility Status
                      </th>
                      <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        Creation Date
                      </th>
                    </tr>

                  </thead>
                  <tbody>
                    {
                      qualitativeProjects?.pagination?.totalDocuments === 0 ?
                        <td colSpan={9}>
                          <div className="py-10">
                            <NoData />
                          </div>
                        </td> : (qualitativeProjects?.data?.map((data, ind) => {
                          return (
                            <tr
                              key={ind}
                              className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                              onClick={(e) => {
                                navigate(`/qualitative-surveys/${data?._id}/research-design`);
                              }}
                            >
                              <td
                                className="px-4 py-3"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  className="w-4 h-4 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] rounded cursor-pointer"
                                  checked={selectRows?.some(
                                    (se) => se?._id == data?.survey?._id,
                                  )}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    if (e.target.checked) {
                                      setSelectRows((prev) => [
                                        ...prev,
                                        data?.survey,
                                      ]);
                                    } else {
                                      setSelectRows(
                                        selectRows?.filter(
                                          (sc) => sc?._id !== data?.survey?._id,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              </td>
                              <td className="px-4 py-3">
                                <div className="flex flex-col gap-2">
                                  <div className="flex items-center gap-2 flex-wrap">
                                    <h2 className="text-[#0226BE] font-[500] text-[13px] max-w-[300px] overflow-hidden text-ellipsis hover:text-[#021ea8] transition-colors">
                                      {data?.projectInfo?.internalProjectTitle}
                                    </h2>
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <div className="flex items-center gap-2 flex-wrap">
                                      <span
                                        className={`text-[#666] font-[400] text-[12px] ${String(
                                          data?.projectNumber,
                                        )?.includes(
                                          debounceSearch?.trim(),
                                        ) &&
                                          debounceSearch?.trim()
                                            ?.length
                                          ? 'bg-yellow-200 px-1 rounded'
                                          : ''
                                          }`}
                                      >
                                        PN#{data?.projectID}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              {tab == 0 &&
                                <td className="px-4 py-3 capitalize text-[#333] font-[400] text-[13px]">
                                  {data?.status}
                                </td>}
                              <td className="px-4 py-3 text-[#333] font-[400] text-[13px] ">
                                {data?.currency?.value} {data?.amount}
                              </td>
                              <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                {data?.totalParticipants || 0}
                              </td>
                              <td className="px-4 py-3 capitalize text-[#333] font-[400] text-[13px]">
                                {data?.feasibilityStatus || 0}
                              </td>
                              <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                <p>{new Date(data?.createdAt)?.toLocaleDateString("en-in", { year: "numeric", month: 'short', day: "numeric" })}, {new Date(data?.createdAt)?.toLocaleTimeString("en-in", { hour: "2-digit", minute: "2-digit" })}</p>
                              </td>
                            </tr>
                          )
                        }))
                    }
                  </tbody>
                </table>
              </div>
          }
          {qualitativeProjects?.pagination?.totalPages > 1 &&
            <CustomTablePagination
              rowsPerPageOptions={[10, 25, 50, 75, 100]}
              sx={{ fontSize: '10px' }}
              count={qualitativeProjects?.pagination?.totalDocuments || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              componentsProps={{
                select: {
                  'aria-label': 'rows per page',
                },
                actions: {
                  showFirstButton: true,
                  showLastButton: true,
                },
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />}
        </div>
      </div>

    </div>
  )
}

export default QualitativeTab